import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { blockSetting as blockSettingApi, devicePermission } from "../../AxiosRtk/DeviceDetail";
import { useHistory } from "react-router-dom";
import useLangTranslation from "../../../customHooks/languageProvider";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import Select from "react-select";
import KidImage from "../../../shared/KidImage/KidImage";
import useFirebase from "../../../../useFirebase";
import { setAddKidStatus } from "../../AxiosRtk/AddNewChild";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";

const permissionTranslations = {
  1: "DEVICE_DETAIL_PERMISSION_DEVICE_ADMIN",
  2: "DEVICE_DETAIL_PERMISSION_APP_USAGE",
  3: "DEVICE_DETAIL_PERMISSION_ACCESSIBILITY",
  4: "DEVICE_DETAIL_PERMISSION_PHONE",
  5: "DEVICE_DETAIL_PERMISSION_DISPLAY_OVER_APP",
  6: "DEVICE_DETAIL_PERMISSION_LOCATION",
  7: "DEVICE_DETAIL_PERMISSION_BATTERY_OPTIMIZATION",
  8: "DEVICE_DETAIL_PERMISSION_CALL_LOG",
  9: "DEVICE_DETAIL_PERMISSION_SCREEN_RECORDING",
  11: "DEVICE_DETAIL_PERMISSION_DISABLE_SAFE_MODE",
  12: "DEVICE_DETAIL_PERMISSION_MIUI",
  13: "PERMISSIONS_NOTIFICATION",
  14: "PERMISSIONS_VPN",
};
const DeviceSettings = () => {
  const [deviceOptions, setDeviceOptions] = useState([]);
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [infoItemShown, setInfoItemShown] = useState(false);
  const { getCollectionData, callFirebase } = useFirebase();
  const dispatch = useDispatch();
  const [blockSetting, setBlockSetting] = useState([
    {
      label: 'DEVICE_DETAIL_BLOCK_SETTING_DESC',
      text: 'Block "Settings" app access on child device',
      key: '',
      status: false,
    },
    {
      label: 'DEVICE_DETAIL_DISABLE_AIRPLANE_MODE',
      text: 'Disable Airplane Mode',
      key: 'disableAirPlaneMode',
      status: false
    },
    {
      label: 'DEVICE_DETAIL_DISABLE_APP_REMOVAL',
      text: 'Disable Kido Protect App Removal',
      key: 'disableAppRemoval',
      status: false
    },
    {
      label: 'DEVICE_DETAIL_DISABLE_MOBILE_DATA',
      text: 'Disable access to Mobile Data',
      key: 'disableMobileData',
      status: false
    },
    {
      label: 'DEVICE_DETAIL_DISABLE_WIFI_DESC',
      text: 'Disable access to WIFI',
      key: 'disableWifi',
      status: false
    },
    {
      label: 'DEVICE_DETAIL_DISABLE_LOCATION_DESC',
      text: 'Disable access to Location',
      key: 'disableLocation',
      status: false
    }
  ]);
  const history = useHistory();
  const [devicePermissions, setDevicePermissions] = useState([]);
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { setRulesData } = useSelector(({ setRules }) => setRules)

  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );

  const selectedKidData = kidList?.find((item) => item?.ID === selectedKidId);
  const { getLangTranslation } = useLangTranslation();

  useEffect(() => {
    function isDeviceSettingAllowed() {
      if (selectedDeviceData) {
        if (selectedDeviceData.IsPermissionSetup !== 1) {
          history.push("/connect-child-device")
          dispatch(setAddKidStatus('CONNECT_CHILD_DEVICE'));
        } else if (selectedDeviceData.isSetupWizardComplete !== 1) {
          history.push("/setup-wizard")
        } else if (selectedDeviceData.IsPermissionSetup === 1 && selectedDeviceData.isSetupWizardComplete === 1) {

          const blockSettingsTemp = [...blockSetting];
          const index = blockSettingsTemp.findIndex((item) => item.label === 'DEVICE_DETAIL_BLOCK_SETTING_DESC');
          if (index !== -1) {
            blockSettingsTemp[index]['status'] = !selectedDeviceData?.IsSettingsBlocked ? false : true
          }

          setBlockSetting(blockSettingsTemp);
          getDevicePermissions(selectedDeviceData?.ID);
          getDeviceStatusData(selectedDeviceData?.ID);
          getCollectionData(selectedDeviceData?.ID);
        }
      }
    }

    if (selectedDeviceData) {
      isDeviceSettingAllowed();
    }
  }, [selectedDeviceData]);

  function getDevicePermissions(deviceId) {
    const obj = {
      deviceId: deviceId,
    };
    devicePermission(obj)
      .then((res) => {
        const devicePermissionData = res?.data?.result?.filter((item) => {
          return item?.PermissionName !== 'Is MiUi Permissions' && item?.PermissionName !== 'Disable Safe Mode' && item?.PermissionName !== 'Keypad Installation'
        }).map((item) => {
          if (item?.PermissionName === 'Read Call Logs Permission') {
            item.PermissionName = 'Calls & SMS logs'
          }
          return item;
        });
        setDevicePermissions(devicePermissionData);
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      });
  }

  const handleBlockSave = (blockSettingToggle) => {
    const obj = {
      kidId: selectedKidId,
      deviceId: selectedDeviceData?.ID,
      case: 116,
      IsBlock: blockSettingToggle === true ? 1 : 0,
      is_load_default_settings: 0,
      packageName: "com.android.settings",
    };
    blockSettingApi(obj)
      .then(() => {
        const blockSettingsTemp = [...blockSetting];
        const index = blockSettingsTemp.findIndex((item) => item.label === 'DEVICE_DETAIL_BLOCK_SETTING_DESC');
        if (index !== -1) {
          blockSettingsTemp[index]['status'] = blockSettingToggle
        }
        setBlockSetting(blockSettingsTemp)
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      });
  };

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  useEffect(() => {
    if (setRulesData.androidRestrictions) {
      const androidRestrictions = setRulesData.androidRestrictions;
      const blockSettingData = [...blockSetting];

      for (const key in androidRestrictions) {
        const index = blockSettingData.findIndex((item) => item?.key === key);
        if (index !== -1) {
          blockSettingData[index]['status'] = androidRestrictions[key]
        }
      }

      setBlockSetting(blockSettingData);
    }
  }, [setRulesData]);

  function handleToggleManuplation(keyLabel, status) {
    const setRulesDataTemp = { ...setRulesData };
    const androidRestrictions = { ...setRulesDataTemp.androidRestrictions };

    for (const key in androidRestrictions) {
      if (keyLabel === key) {
        androidRestrictions[key] = status;
      }
    }

    const collectionPayload = {
      ...setRulesDataTemp,
      androidRestrictions
    }

    callFirebase(selectedDeviceData?.ID, collectionPayload);
  }

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  function handleAlertShow() {
    setInfoItemShown(true);
    setTimeout(() => {
      setInfoItemShown(false);
    }, 3000);
  }

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div
                  className="d-inline-flex align-items-center lh-1 c-pointer"
                  onClick={() => history.goBack()}
                >
                  <i
                    className={`text-blue-900 fs-5 ${lang?.isRTL === 1 ? "icon-arrow-right" : "icon-arrow-left"
                      }`}
                  />
                  <h3 className="text-blue-900 mb-0 text-capitalize">{`${getLangTranslation(
                    "DASHBOARD_DEVICE_SETTINGS",
                    "Device Settings"
                  )}`}</h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage
                imageUrl={selectedKidData?.image}
                gender={selectedKidData?.gender}
              />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">
                  {selectedKidData?.childName}
                </h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value === selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          {infoItemShown && (
            <div
              className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
              role="alert"
            >
              <i className="icon-info-one fs-5" />
              {getLangTranslation(
                "FEATURE_AVAILABLE_INSTALL_FROM_WINDOW_APP",
                "These options are only available for child's devices paired by our PC Windows Tool."
              )}
            </div>
          )}

          <div className="gap-3">
            <div>
              <h5 className="mb-6">
                {getLangTranslation(
                  "DEVICE_DETAIL_BLOCK_SETTING",
                  "Block settings"
                )}
              </h5>
            </div>
            {
              blockSetting?.map((blockSetting) => {
                return (
                  <div
                    className={`form-check form-switch mt-2 ${lang?.isRTL === 1 ? "ms-auto" : "me-auto"
                      }`}
                    key={blockSetting.label}
                  >
                    <input
                      className="form-check-input c-pointer"
                      id={blockSetting.label}
                      type="checkbox"
                      role="switch"
                      checked={blockSetting.status}
                      onChange={(e) => {
                        if (blockSetting.label === 'DEVICE_DETAIL_BLOCK_SETTING_DESC') {
                          handleBlockSave(e.target.checked);
                        } else if (selectedDeviceData?.buildType === 1) {
                          handleToggleManuplation(blockSetting.key, e.target.checked);
                        } else if (selectedDeviceData?.buildType === 0) {
                          handleAlertShow();
                        }
                      }}
                    />
                    <label
                      className="form-check-label text-dark c-pointer"
                      htmlFor={blockSetting.label}
                    >
                      {getLangTranslation(
                        blockSetting.label,
                        blockSetting.text
                      )}
                    </label>
                  </div>
                )
              })
            }
          </div>
          <hr className="my-6"></hr>
          <h5 className="mb-6">
            {getLangTranslation(
              "DEVICE_DETAIL_DEVICE_PERMISSION",
              "Device permissions"
            )}
          </h5>
          <div className="row">
            {devicePermissions?.length > 0 && selectedDeviceData ? (
              devicePermissions?.map((item) => {
                const translationKey = permissionTranslations[item?.PermissionID];

                return (
                  <div
                    key={item?.PermissionID}
                    className="col-6 py-6 border-bottom"
                  >
                    <div className="form-check me-auto">
                      <span>
                        {" "}
                        <input
                          className="form-check-input"
                          id="CallLogs"
                          type="checkbox"
                          value="option1"
                          defaultChecked={item?.IsEnabled === 1 ? true : false}
                          disabled
                        />
                      </span>
                      <label className="form-check-label" htmlFor="CallLogs">
                        {translationKey
                          ? getLangTranslation(translationKey, item?.PermissionName)
                          : item?.PermissionName}
                      </label>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className="form-check me-auto text-center my-2">
                {getLangTranslation(
                  "PERMISSION_NOT_EXISTS",
                  "Permission does not exist!"
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DeviceSettings;
